import SessionQrPanelActionTypes from './session-qr-panel-action-types';

export const loadSessionQr = (payload) => async(dispatch, getState, { api }) => {
  dispatch({ type: SessionQrPanelActionTypes.LOAD_SESSION_QR_START });
  try {
    const qr = await api.get(`api/general_competency_events/${payload.eventId}/sessions/${payload.sessionId}/qr`);
    if (qr?.validFrom) {
      qr.validFrom = new Date(qr.validFrom);
    }
    if (qr?.validUntil) {
      qr.validUntil = new Date(qr.validUntil);
    }
    dispatch({
      type: SessionQrPanelActionTypes.LOAD_SESSION_QR_END,
      payload: { qr: qr || null }
    });
  } catch (error) {
    dispatch({ type: SessionQrPanelActionTypes.LOAD_SESSION_QR_END });
    throw error;
  }
};

export const generateSessionQr = (payload) => async(dispatch, getState, { api }) => {
  dispatch({ type: SessionQrPanelActionTypes.GENERATE_SESSION_QR_START });
  try {
    await api.post(`api/general_competency_events/${payload.eventId}/sessions/${payload.sessionId}/qr`);
    dispatch({ type: SessionQrPanelActionTypes.GENERATE_SESSION_QR_END });
    dispatch(loadSessionQr(payload));
  } catch (error) {
    dispatch({ type: SessionQrPanelActionTypes.GENERATE_SESSION_QR_END });
    throw error;
  }
};

export const rotateSessionQr = (payload) => async(dispatch, getState, { api }) => {
  dispatch({ type: SessionQrPanelActionTypes.GENERATE_SESSION_QR_START });
  try {
    await api.put(`api/general_competency_events/${payload.eventId}/sessions/${payload.sessionId}/qr/${payload.qrId}/rotate`);
    dispatch({ type: SessionQrPanelActionTypes.GENERATE_SESSION_QR_END });
    dispatch(loadSessionQr(payload));
  } catch (error) {
    dispatch({ type: SessionQrPanelActionTypes.GENERATE_SESSION_QR_END });
    throw error;
  }
};

export const disableSessionQr = (payload) => async(dispatch, getState, { api }) => {
  dispatch({ type: SessionQrPanelActionTypes.GENERATE_SESSION_QR_START });
  try {
    await api.put(`api/general_competency_events/${payload.eventId}/sessions/${payload.sessionId}/qr/${payload.qrId}/disable`);
    dispatch({ type: SessionQrPanelActionTypes.GENERATE_SESSION_QR_END });
    dispatch(loadSessionQr(payload));
  } catch (error) {
    dispatch({ type: SessionQrPanelActionTypes.GENERATE_SESSION_QR_END });
    throw error;
  }
};
